if (!customElements.get('mle-mobile-thumb-menu')) {
  class MleMobileThumbMenu extends HTMLElement {
    constructor() {
      super();
      this.updatePanelPosition = this.updatePanelPosition.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.button = this.querySelector('.site-nav__thumb-button');
      if (!this.section || !this.button) return;

      this.resizeObserver = new ResizeObserver(this.updatePanelPosition);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.button);
      window.addEventListener('resize', this.updatePanelPosition, { passive: true });
      this.updatePanelPosition();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updatePanelPosition);
    }

    updatePanelPosition() {
      const style = getComputedStyle(this);
      // Layout offsets exclude the bar's off-screen entrance transform.
      const bottom = (parseFloat(style.bottom) || 0) + (parseFloat(style.marginBottom) || 0)
        + this.offsetHeight - this.button.offsetTop;
      this.section.style.setProperty('--mobile-thumb-panel-bottom', `${bottom}px`);
      this.section.style.setProperty('--mobile-thumb-panel-left', `${this.button.getBoundingClientRect().left}px`);
      this.section.style.setProperty('--mobile-thumb-panel-width', `${this.button.offsetWidth}px`);
    }
  }

  customElements.define('mle-mobile-thumb-menu', MleMobileThumbMenu);
}
